import { KPIEvent, KPIStatus } from "PFCore/types/kpi";

export const isSystemEvent = (event: KPIEvent) =>
  !event.status || [KPIStatus.OnTarget, KPIStatus.ApprovalRequired].includes(event.status);

export const isEvaluationErrorEvent = (event: KPIEvent) => !event.status || event.value === null;
